import React from 'react';
import './Spinner.css'; // Asegúrate de que este archivo CSS esté en la misma carpeta o ajusta la ruta
import { image } from "../../../assets";
import { Image } from "semantic-ui-react";

const Spinner = ({ text }) => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner">
        <Image src={ image.search }/>
      </div>
      <div className="spinner-text">{text}</div>
    </div>
  );
};

export default Spinner;
